// 公共常量

// 默认语言
export const DEFAULT_LANGUAGE = 'zh-CN';

// Token Key
export const TOKEN_KEY = 'spop_openatom_oatc_admin_api_token';

// 资讯编辑器类型本地存储 Key
export const NEWS_CONTENT_FORMAT_KEY = 'spop_openatom_oatc_admin_news_content_format';

// 编辑器格式偏好的本地存储 key
export const FAQ_ARTICLE_CONTENT_FORMAT_KEY = 'spop_openatom_oatc_admin_faq_article_content_format';

// 站点内容编辑器格式偏好的本地存储 key
export const SITE_CONTENT_FORMAT_KEY = 'spop_openatom_oatc_admin_site_content_format';
